// The Media Buying tabs a Team Leader can be granted, mirrored from
// lib/mediaBuying/leaderPerms.js on the server — which owns the catalog, the
// "unset means allowed" rule and the forbidden list, and is the only place any
// of it is enforced. Kept in step by test/mediaBuying/leaderPermsMirror.test.js.
//
// Only the two things the UI needs live here: the tab list (to render the nav
// and the admin toggles in a fixed order) and the path→tab lookup. The
// defaulting rule is NOT duplicated: the server ships a complete answer for
// every tab on getMe(), so the client looks it up rather than deriving it.
export const LEADER_PERM_TABS = Object.freeze([
  { key: "overview", label: "Overview", path: "media-buying/overview", locked: true },
  { key: "myTeam", label: "My Team", path: "media-buying/my-team" },
  { key: "clients", label: "Clients", path: "media-buying/clients" },
  { key: "buyers", label: "Media Buyers", path: "media-buying/buyers" },
  { key: "interns", label: "Interns", path: "media-buying/interns" },
  { key: "projects", label: "Projects", path: "media-buying/projects" },
  { key: "feedback", label: "Feedback", path: "media-buying/feedback" },
  { key: "scaling", label: "Scaling", path: "media-buying/scaling" },
  { key: "creatives", label: "Creatives", path: "media-buying/creatives" },
  { key: "partners", label: "Partners", path: "media-buying/partners" },
  { key: "manage", label: "Manage", path: "media-buying/manage" },
]);

const BY_PATH = new Map(LEADER_PERM_TABS.map((t) => [t.path, t]));

export const leaderTabForPath = (path) => BY_PATH.get(String(path || "")) || null;
